// extracted by mini-css-extract-plugin
export default {"infoBlockFooter":"index_infoBlockFooter__Ozl1w","style-detail-button":"index_style-detail-button__khbIA"};